<template>
    <div class="app-content-pane">
        <div class="title">
            <slot name="title"></slot>
        </div>
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: "AppContentPane"
}
</script>

<style lang="scss" scoped>
.app-content-pane{
    box-shadow: 0 0 6px #00000029;
    border-radius: 6px 0 0 6px;
}
.title{

}
</style>
